import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { ModalController } from '@ionic/angular';
import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { getAuth, signOut } from "firebase/auth";
import{RegisterAswholesellerPage} from 'src/app/pages/register-aswholeseller/register-aswholeseller.page'
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.page.html',
  styleUrls: ['./account.page.scss'],
})
export class AccountPage implements OnInit {
user: any = {};
loggedIn: boolean = false
userId = localStorage.getItem('userId');
a: any;
name : any;
check: boolean=false;
phone : any;
retailerEnabled:any;
  constructor(
    public userService: UserService,
    public modalController: ModalController,
    private router: Router,
    public alertController : AlertController,private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.userService.profileUpdated.subscribe(res => {
      this.ionViewWillEnter();
    })
    
  }

  ionViewWillEnter(){
    this.a=this.userService.uid;
    console.log(this.a,"Shraddha USer login firebase UID value a")
    if(this.a){
      this.check=true;
    }else{
      this.check=false
    }
    let data={
      uid : this.a
    }
    this.userService.getUserDetails(data).subscribe((res:any)=>{
      console.log("Login Account response",res);
      if(res){
        this.userId=res._id
        localStorage.setItem("userId", this.userId)
        console.log("dsfdg", this.userId)
      }
      this.name=res.name;
      this.phone=res.phone;
      if(res.retailerEnabled==1){
        this.retailerEnabled=1
      }else{
        this.retailerEnabled=0
      }
console.log(  "retailer flag",this.retailerEnabled)
    })
  }

  // async login() {

  //   const modal = await this.modalController.create({
  //     component: LoginPage,
  //     animated: true,
  //     cssClass: 'my-custom-modal-css'
  //   });

  //   modal.present();

  //   const { data } = await modal.onWillDismiss();
  //   if (data) {}

  // }

  login(){
    this.router.navigate(['/login'])
  }

  home(){
    this.router.navigate(['/'])
  }

  logout(){
    // localStorage.clear();
    // sessionStorage.clear();
    localStorage.removeItem("retailerEnabled");
  //  localStorage.clear()
    const auth = getAuth();
    signOut(auth).then(() => {
    // Sign-out successful.
    this.userService.uid=null;
    this.ionViewWillEnter()
     }).catch((error) => {
      // An error happened.
  
});
      // this.ionViewWillEnter()
    this.router.navigate(['/'])
  }

  orderHistory(){
    if (this.userService.uid) {
    this.router.navigate(['/order-history'])
  }
  else{
    this.router.navigate(['/login'])
  }}
  wallet(){
    if (this.userService.uid) {
    this.router.navigate(['/spot-wallet'])
  }
  else{
    this.router.navigate(['/login'])
  }
}

  rIssue(){
    this.router.navigate(['/raise-issue'])
  }

  wishlist(){
    this.router.navigate(['/wishlist'])
  }

  // async presentAlert() {
  //   const alert = await this.alertController.create({
  //     cssClass: 'my-custom-class',
  //     header: 'Contact Us',
  //     subHeader: 'Send email with your query at',
  //     message: 'noreply@spotcustomers.com',
  //     buttons: ['OK']
  //   });
  
  //   await alert.present();
  // }
  present() {
    this.router.navigate(["/contact"])
  }
  offers(){
    this.router.navigate(['/login'])
  }

  profile(){
   
    this.router.navigate(['/profile'])
  }
  async b2bRegistration(item: any) {
    const modal = await this.modalController.create({
      component: RegisterAswholesellerPage,
      // componentProps: {
      //   'model_title': item
      // }
    });
    modal.onDidDismiss().then((modelData) => {
      // if (modelData !== null) {
      //   this.modelData = modelData.data;
       
      //   console.log('Modal Data : ' + modelData);
      // }
    });
    return await modal.present();
  }

}
